import { z } from "zod";

/**
 * Schémata pro GET /api/admin/documents a GET /api/admin/sync/runs/{id}.
 * Snake_case z backendu zachované — UI transformuje při renderu.
 */

export const AdminDocumentRow = z.object({
  id: z.string().uuid(),
  sync_run_id: z.string().uuid(),
  zone_id: z.string().uuid(),
  zone_code: z.string(),
  axigon_doc_id: z.string(),
  doc_type: z.string(),
  period_from: z.string().nullable(),
  period_to: z.string().nullable(),
  duzp: z.string().nullable(),
  splatnost: z.string().nullable(),
  total_amount: z.string().nullable(),
  vat_amount: z.string().nullable(),
  currency: z.string().nullable(),
  source_method: z.string().nullable(),
  storage_key: z.string(),
  storage_backend: z.string(),
  file_format: z.string(),
  size_bytes: z.number().int().nonnegative(),
  status: z.string(),
  fetched_at: z.string(),
});
export type AdminDocumentRow = z.infer<typeof AdminDocumentRow>;

export const AdminDocumentsResponse = z.object({
  documents: z.array(AdminDocumentRow),
  total: z.number().int().nonnegative(),
  limit: z.number().int().positive(),
});
export type AdminDocumentsResponse = z.infer<typeof AdminDocumentsResponse>;

export const AdminSyncRunDetail = z.object({
  sync_run_id: z.string().uuid(),
  zone_id: z.string().uuid(),
  zone_code: z.string(),
  state: z.string(),
  started_at: z.string(),
  finished_at: z.string().nullable(),
  duration_seconds: z.number().nullable(),
  inventory_count: z.number().int().nullable(),
  error_payload: z.unknown().nullable(),
  triggered_by: z.string().nullable(),
  document_count: z.number().int().nonnegative(),
  transaction_count: z.number().int().nonnegative(),
  documents: z.array(AdminDocumentRow),
});
export type AdminSyncRunDetail = z.infer<typeof AdminSyncRunDetail>;

export interface AdminDocumentsFilters {
  zoneId?: string;
  docType?: string;
  periodFrom?: string;
  periodTo?: string;
  q?: string;
}

export function buildDocumentsQueryString(filters: AdminDocumentsFilters): string {
  const params = new URLSearchParams();
  if (filters.zoneId) params.set("zoneId", filters.zoneId);
  if (filters.docType) params.set("docType", filters.docType);
  if (filters.periodFrom) params.set("periodFrom", filters.periodFrom);
  if (filters.periodTo) params.set("periodTo", filters.periodTo);
  if (filters.q) params.set("q", filters.q);
  const qs = params.toString();
  return qs ? `?${qs}` : "";
}
